import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Projects from "@/pages/Projects";

export const Route = createFileRoute("/_site/projects/")({
  head: () => ({
    ...seo({
      title: "Recent Projects | Kodiak Structures & Exteriors",
      description:
        "View recent roofing, siding, and exterior projects completed by Kodiak Structures & Exteriors across Minnesota.",
      path: "/projects",
    }),
  }),
  component: Projects,
});
